import { render, staticRenderFns } from "./ComplianceFiles.vue?vue&type=template&id=26be3224&"
import script from "./ComplianceFiles.vue?vue&type=script&lang=js&"
export * from "./ComplianceFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports